import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuestGuard } from './modules/core/guards/guest.guard';
import { AuthGuard } from './modules/core/guards/auth.guard';
import { FullNavigationComponent } from './modules/core/components/full-navigation/full-navigation.component';

const routes: Routes = [
  {
    path: '',
    component: FullNavigationComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'data',
        loadChildren: () =>
          import('./modules/data/data.module').then(
            (module) => module.DataModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'coupon-management',
        loadChildren: () =>
          import('./modules/coupon-management/coupon-management.module').then(
            (module) => module.CouponManagementModule
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((module) => module.AuthModule),
    canActivate: [GuestGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
